export const PaymentTypes = {
  Wallet: 'Wallet',
  CreditCard: 'CREDITCARD',
} as const;
